export const profileHelper = (char) => {
    let color,
        str = char.toLowerCase();
    switch (str) {
        case "a":
            color = "#DE3163";
            break;
        case "b":
            color = "#FF7F50";
            break;
        case "c":
            color = "#6495ED";
            break;
        case "d":
            color = "#DFFF00";
            break;
        case "e":
            color = "#CCCCFF";
            break;
        case "f":
            color = "#FFBF00";
            break;
        case "g":
            color = "#40E0D0";
            break;
        case "h":
            color = "#9FE2BF";
            break;
        case "i":
            color = "#CCCCFF";
            break;
        case "j":
            color = "#FF7F50";
            break;
        case "k":
            color = "#DFFF00";
            break;
        case "l":
            color = "#DE3163";
            break;
        case "m":
            color = "#FF7F50";
            break;
        case "n":
            color = "#FFBF00";
            break;
        case "o":
            color = "#DFFF00";
            break;
        case "p":
            color = "#CCCCFF";
            break;
        case "q":
            color = "#6495ED";
            break;
        case "r":
            color = "#9FE2BF";
            break;
        case "s":
            color = "#40E0D0";
            break;
        case "t":
            color = "#40E0D0";
            break;
        case "u":
            color = "#9FE2BF";
            break;
        case "v":
            color = "#6495ED";
            break;
        case "w":
            color = "#CCCCFF";
            break;
        case "x":
            color = "#DFFF00";
            break;
        case "y":
            color = "#FFBF00";
            break;
        case "z":
            color = "#FF7F50";
            break;
        default:
            color = "#FF7F50"
    }

    return color;
}

export const timeSince = (date) => {
    var seconds = Math.floor((new Date() - new Date(date)) / 1000);
    var interval = seconds / 31536000;
    if (interval > 1) {
        return Math.floor(interval) + " y";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
        return Math.floor(interval) + " mon";
    }
    interval = seconds / 86400;
    if (interval > 1) {
        return Math.floor(interval) + " d";
    }
    interval = seconds / 3600;
    if (interval > 1) {
        return Math.floor(interval) + " h";
    }
    interval = seconds / 60;
    if (interval > 1) {
        return Math.floor(interval) + " min";
    }
    return Math.abs(Math.floor(seconds)) + " sec";
}